import { useContext } from 'react';
import { i18n } from '@lingui/core';
import { Stack, Text } from '@mantine/core';
import { ProfileContext } from '../Service/Context/ProfileContext';
import BookitupTextInput from '../Atoms/inputs/BookitupTextInput';
import BookitupNumberInput from '../Atoms/inputs/BookitupNumberInput';
import PanePaper from './PanePaper';

const FinancialForm = () => {
  const { profile, patchProfile } = useContext(ProfileContext);
  const { monthlyTurnover, taxOffice, taxNumber, vatId } = profile ?? {};

  return (
    <PanePaper title="common.settings.finance">
      <Stack spacing="xs">
        <BookitupNumberInput
          label={i18n._('applicationuser.monthlyturnover')}
          defaultValue={monthlyTurnover}
          onBlurSave={(val) => patchProfile({ monthlyTurnover: val as any })}
          rightSection={
            <Text size="xs" weight="bolder" mr={15}>
              EUR
            </Text>
          }
        />
        <BookitupTextInput
          label={i18n._('applicationuser.taxoffice')}
          defaultValue={taxOffice}
          onBlurSave={(val) => patchProfile({ taxOffice: val })}
        />
        <BookitupTextInput
          label={i18n._('applicationuser.taxnumber')}
          defaultValue={taxNumber}
          onBlurSave={(val) => patchProfile({ taxNumber: val })}
        />
        <BookitupTextInput
          label={i18n._('applicationuser.vatid')}
          defaultValue={vatId}
          onBlurSave={(val) => patchProfile({ vatId: val })}
        />
      </Stack>
    </PanePaper>
  );
};

export default FinancialForm;
